/*  ==============================================
//  Created by nguyendx                          ||
//  create at: 2017-10-10                        ||
//===============================================*/
import {Component, Injectable, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {ConfirmationService} from 'primeng/primeng';
import {Location} from '@angular/common';
import {EvsScanStampService} from '../../../../common/services/EvsScanStamp.service';
import {ModalInfoService} from '../../../../common/services/ModalInfo.service';

declare var $: any;

@Component({
    moduleId: module.id,
    selector: "scan_stamp_qrm",
    templateUrl: './scan_stamp.component.html',
    styleUrls: ['./scan.css'],
    providers: [ConfirmationService, EvsScanStampService]
})

@Injectable()
export class ScanStampComponent implements OnInit {
    public routerChange: any;
    public code = {};
    public message: { class: string, content: string } = null;
    public isError: boolean = false;

    public isBaoHanh: boolean = false;
    public isTranHang: boolean = false;
    public isChongGia: boolean = false;
    public isNotActive: boolean = false;

    public mStamp: any;
    public mMessages: any;
    public mProduct: any;
    public mProductInfo: any;
    public mVendor: any;
    public mBusiness: any;
    public mOther_product: any;

    constructor(private _location: Location,
                private router: Router,
                private scanService: EvsScanStampService,
                private activatedRoute: ActivatedRoute,
                private confirmationService: ConfirmationService,
                private mdInfo: ModalInfoService,
                private _fb: FormBuilder) {
        let body = document.getElementsByTagName('body')[0];
        body.classList.add("animsition");
        body.classList.add("layout-full");
    }

    ngOnInit() {
        this.routerChange = this.activatedRoute.params.subscribe((params: Params) => {
            if (params['qrm']) {
                this.code = {qrm: params['qrm']};
                this.scanByQrm(this.code);
            } else if (params['code_id']) {
                this.code = {code: params['code_id']};
                this.scanByCodeId(this.code);
            }
        });
    }

    getData(res: any) {
        $('.mScan').css({'display': 'block', 'opacity': '0'}).animate({'opacity': '1', 'top': '5%'}, 500);
        this.isError = res.error;
        let mData = res.data;
        if (this.isError === true) {
            this.message = {
                class: "statusInfo alert dark alert-danger",
                content: res.message
            };
        } else if (this.isError === false) {
            this.mStamp = mData.stamp;
            this.mProduct = mData.product;
            this.mBusiness = mData.business;
            this.mMessages = mData.messages;
            this.mOther_product = mData.other_product;
            if (this.mProduct.sku) {
                let sku = this.mProduct.sku;
                // let sku = '8856036000017';
                //get vendor  from icheck
                this.scanService.getVendor(sku).toPromise().then(res => {
                    let vendor = res.data.vendor;
                    if (vendor == null || vendor == undefined || vendor == "") {
                        this.mVendor = {};
                    } else {
                        this.mVendor = vendor;
                    }
                }, err => {
                    throw new Error('This request getVendor failed: ' + err.message);
                    // this.mdInfo.show(err.message);
                });
                //get product info from icheck by sku
                this.scanService.getProuctInfo(sku).toPromise().then(res => {
                    let info = res.data.attributes;
                    if (info == null || info == undefined || info == "") {
                        // this.mProductInfo = [];
                    } else {
                        this.mProductInfo = info;
                    }
                }, err => {
                    throw new Error('This request getProuctInfo failed: ' + err.message);
                });
            }
            // check services stamp
            let service = this.mStamp.stamp_service;
            if (service === 1) {// chong gia
                this.isChongGia = true;
            } else if (service === 2) {// chong gia theo so lan
                this.isChongGia = true;
            } else if (service === 3) {// bao hanh
                this.isBaoHanh = true;
            } else if (service === 4) {// tran hang
                this.isTranHang
            } else if (service === '2,3') {// trang hang + bao hanh
                this.isBaoHanh = true;
                this.isTranHang = true;
            }
        }
    }

    scanByQrm(qrm: any) {
        this.scanService.scanQrm(qrm).toPromise().then(res => {
            this.getData(res);
        }, err => {
            this.isError = true;
            this.message = {
                class: "statusInfo alert dark alert-danger",
                content: err.message
            };
            // throw new Error('This request scanByQrm failed: ' + err.message);
        });
    }

    scanByCodeId(code: any) {
        this.scanService.scanCodeId(code).toPromise().then(res => {
            this.getData(res);
        }, err => {
            this.isError = true;
            this.isError = true;
            this.message = {
                class: "statusInfo alert dark alert-danger",
                content: err.message
            };
            // throw new Error('This request scanByCodeId failed: ' + err.message);
        });
    }

    backToComponent() {
        this._location.back();
    }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/scan/scan_stamp.component.ts